export default "__VITE_ASSET__D9_WCqV1__"